var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState, } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { cx, css as emotionCss } from 'emotion';
import { Icon } from '@citrus/icon';
import { getAutomation, getStyleNames, useCitrusDebug } from '@citrus/runtime';
import { isNilOrEmpty, isNotNilOrEmpty, removeKeys } from '@pcty/utils';
import { useTheme } from '@citrus/user';
import { ACTIVATE_BUTTONS as activateButtons } from '../constants';
import { clearButtonFocusStyles, inputBaseNormalState, inputBaseDisabledState, inputBaseErrorState, inputBaseInputStyles, inputDropdownFocus, inputBasePlaceholderStyles, } from '../../../styles/legacy';
import { clearButtonFocusStyles as clearButtonFocusStylesCitrus2022, inputBaseNormalState as inputBaseNormalStateCitrus2022, inputBaseDisabledState as inputBaseDisabledStateCitrus2022, inputBaseErrorState as inputBaseErrorStateCitrus2022, inputBaseInputStyles as inputBaseInputStylesCitrus2022, inputDropdownFocus as inputDropdownFocusCitrus2022, inputBasePlaceholderStyles as inputBasePlaceholderStylesCitrus2022, } from '../../../styles/citron';
import { InputBaseActionArea, InputBaseClearButton, InputBaseInputButtonContainer, InputBaseInputHolder, InputBaseInputWrapper, InputBaseLabel, InputBaseSeparator, InputContainerBase, InputFullContainer, InputIconBase, InputLoader, } from '../../Select.styled';
import { useKeyPress } from '../utils/useKeyPress';
var InputBase = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var _d, _e, _f, _g, _h;
    var _j = _a.autocomplete, autocomplete = _j === void 0 ? false : _j, actionAreaRef = _a.actionAreaRef, _k = _a.actionIconSeparator, actionIconSeparator = _k === void 0 ? false : _k, ariaLabel = _a["aria-label"], automationId = _a.automationId, className = _a.className, css = _a.css, debounceTimeout = _a.debounceTimeout, disabled = _a.disabled, _l = _a.hidePlaceholder, hidePlaceholder = _l === void 0 ? false : _l, id = _a.id, _m = _a.isLoading, isLoading = _m === void 0 ? false : _m, _o = _a.isTyping, isTyping = _o === void 0 ? true : _o, maxLength = _a.maxLength, onChange = _a.onChange, onClearButton = _a.onClearButton, onInputFocus = _a.onInputFocus, onKeyDown = _a.onKeyDown, placeholder = _a.placeholder, _p = _a.readOnly, readOnly = _p === void 0 ? false : _p, renderActionIcon = _a.renderActionIcon, renderInputActionArea = _a.renderInputActionArea, _q = _a.showClearButton, showClearButton = _q === void 0 ? false : _q, _r = _a.tabIndex, tabIndex = _r === void 0 ? 0 : _r, valid = _a.valid, _s = _a.value, value = _s === void 0 ? '' : _s, other = __rest(_a, ["autocomplete", "actionAreaRef", "actionIconSeparator", 'aria-label', "automationId", "className", "css", "debounceTimeout", "disabled", "hidePlaceholder", "id", "isLoading", "isTyping", "maxLength", "onChange", "onClearButton", "onInputFocus", "onKeyDown", "placeholder", "readOnly", "renderActionIcon", "renderInputActionArea", "showClearButton", "tabIndex", "valid", "value"]);
    var FOCUS_DEBUG = false;
    var debug = useCitrusDebug();
    var isCitron = useTheme().citrus2022;
    var _t = useState(false), inputFocus = _t[0], setInputFocus = _t[1];
    var _u = useState(false), clearButtonFocus = _u[0], setClearButtonFocus = _u[1];
    var _v = useState(hidePlaceholder ? '' : value), label = _v[0], setLabel = _v[1];
    var inputIconToggle = useState(false)[0];
    var inputStyles = isCitron ? inputBaseInputStylesCitrus2022 : inputBaseInputStyles;
    var normalStyles = isCitron ? inputBaseNormalStateCitrus2022 : inputBaseNormalState;
    var disabledStyles = isCitron ? inputBaseDisabledStateCitrus2022 : inputBaseDisabledState;
    var errorStyles = isCitron ? inputBaseErrorStateCitrus2022 : inputBaseErrorState;
    var dropdownFocusStyles = isCitron ? inputDropdownFocusCitrus2022 : inputDropdownFocus;
    var clrButtonFocusStyles = isCitron ? clearButtonFocusStylesCitrus2022 : clearButtonFocusStyles;
    var placeholderStyles = isCitron ? inputBasePlaceholderStylesCitrus2022 : inputBasePlaceholderStyles;
    var textInput = ref;
    var textInputIcon = useRef(null);
    var clearButtonIcon = useRef(null);
    var otherProps = removeKeys(other, ['ref', '__TYPE']);
    var inputContainerClasses = cx({
        'pcty-input-select-input-container': true,
    });
    var emotionObj = (_b = {},
        _b[emotionCss(errorStyles)] = !valid,
        _b['pcty-input-select-full-container'] = true,
        _b[emotionCss(normalStyles)] = true,
        _b[emotionCss(disabledStyles)] = disabled,
        _b[emotionCss(dropdownFocusStyles)] = inputFocus || FOCUS_DEBUG,
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b);
    var inputBaseExtraStyles = cx(emotionObj, className || '');
    var styleNames = (_c = {
            errorStyles: (_d = emotionObj[emotionCss(errorStyles)]) !== null && _d !== void 0 ? _d : false,
            normalStyles: (_e = emotionObj[emotionCss(normalStyles)]) !== null && _e !== void 0 ? _e : false,
            disabledStyles: (_f = emotionObj[emotionCss(disabledStyles)]) !== null && _f !== void 0 ? _f : false,
            dropdownFocusStyles: (_g = emotionObj[emotionCss(dropdownFocusStyles)]) !== null && _g !== void 0 ? _g : false,
            css: (_h = emotionObj[emotionCss(css)]) !== null && _h !== void 0 ? _h : false
        },
        _c['pcty-input-select-full-container'] = true,
        _c);
    useEffect(function () {
        var valueString = isNilOrEmpty(value) ? '' : value;
        setLabel(valueString);
    }, [value]);
    var handleClearButtonClick = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        textInput.current.focus();
        if (onClearButton && onClearButton !== undefined && onClearButton !== null) {
            return onClearButton({ value: '' });
        }
        return onChange({ value: '' });
    };
    var handleOnChange = function (value) { return onChange(value); };
    var handleInputOnChange = function (e) {
        if (!isTyping)
            return;
        var value = e.target.value;
        var retValue = value.length && value === ' ' ? '' : value;
        handleOnChange({ value: retValue });
    };
    var handleInputContainerMouseDownFocus = function (e) {
        if (disabled || textInput.current === document.activeElement)
            return;
        e.preventDefault();
        e.stopPropagation();
        textInput.current.focus();
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    };
    var getLabelElement = function () {
        var _a;
        if (inputFocus)
            return null;
        var retLabel = label || placeholder || 'Select an Item';
        var hasLabel = (label === null || label === void 0 ? void 0 : label.length) > 0;
        var labelClasses = cx((_a = {},
            _a[emotionCss({ color: normalStyles.color })] = !disabled && hasLabel,
            _a[emotionCss({ color: placeholderStyles.color })] = !disabled && !hasLabel,
            _a[emotionCss({ color: disabledStyles.color })] = disabled,
            _a));
        return React.createElement(InputBaseLabel, { className: labelClasses }, !hidePlaceholder ? retLabel : '');
    };
    var getClearButton = function () {
        var _a;
        if (!showClearButton || disabled)
            return null;
        var handleKeyPress = function (e) {
            e.stopPropagation();
            if (disabled) {
                return;
            }
            // eslint-disable-next-line react-hooks/rules-of-hooks
            var activeButton = useKeyPress(e, activateButtons);
            if (clearButtonIcon.current === document.activeElement && activeButton) {
                return handleClearButtonClick();
            }
        };
        var emotionObj = (_a = {},
            _a[emotionCss(clrButtonFocusStyles)] = clearButtonFocus,
            _a);
        var clearButtonClasses = cx(emotionObj);
        var styleNames = {
            clrButtonFocusStyles: emotionObj[emotionCss(clrButtonFocusStyles)],
        };
        var clearButtonSize = isCitron ? 'small' : 'xsmall';
        return (React.createElement(InputBaseClearButton, { className: clearButtonClasses, onBlur: function () { return setClearButtonFocus(false); }, onFocus: function () { return setClearButtonFocus(true); }, onKeyDown: handleKeyPress, onMouseDown: function (e) { return handleClearButtonClick(e); }, ref: clearButtonIcon, styleNames: getStyleNames(styleNames), tabIndex: 0 },
            React.createElement(Icon, { bold: isCitron, name: "delete", size: clearButtonSize, title: "delete" })));
    };
    var getInputElement = function () {
        var _a;
        var handleInputWatcher = function (e) {
            e.stopPropagation();
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        };
        var handleInputFocusEvent = function (e) {
            if (e.type === 'focus') {
                setInputFocus(true);
                onInputFocus === null || onInputFocus === void 0 ? void 0 : onInputFocus(true); // don't use the inputFocus flag, as it changes!
            }
            else if (e.type === 'blur') {
                setInputFocus(false);
                onInputFocus === null || onInputFocus === void 0 ? void 0 : onInputFocus(false); // don't use the inputFocus flag, as it changes!
            }
        };
        var emotionObj = (_a = {},
            _a[emotionCss(inputStyles)] = true,
            _a);
        var classes = cx(emotionObj);
        var styleNames = {
            inputStyles: emotionObj[emotionCss(inputStyles)],
        };
        return (React.createElement(InputBaseInputWrapper, { className: "pcty-input-select__input" },
            React.createElement(DebounceInput, { "aria-autocomplete": "list", "aria-label": ariaLabel, autoCapitalize: "none", autoComplete: autocomplete ? new Date().getTime() : undefined, autoCorrect: "off", className: classes, "data-style": debug ? getStyleNames(styleNames).join(', ') : undefined, debounceTimeout: debounceTimeout, disabled: disabled, id: id, inputRef: textInput, maxLength: maxLength, onBlur: handleInputFocusEvent, onChange: handleInputOnChange, onFocus: handleInputFocusEvent, onKeyDown: handleInputWatcher, onMouseDown: handleInputWatcher, readOnly: readOnly, required: other === null || other === void 0 ? void 0 : other.required, spellCheck: "false", tabIndex: tabIndex, type: "text", value: inputFocus ? value : '' })));
    };
    var getInputIcons = function () {
        var _a;
        if (!renderActionIcon)
            return null;
        var handleIconMouseDown = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (disabled || textInput.current === document.activeElement)
                return;
            textInput.current.focus();
        };
        var inputIconBaseClasses = cx((_a = {},
            _a[emotionCss({ cursor: 'not-allowed' })] = disabled,
            _a['pcty-input-select__dropdown-icon'] = true,
            _a));
        return (React.createElement("div", { onMouseDown: function (e) { return handleIconMouseDown(e); } },
            actionIconSeparator && React.createElement(InputBaseSeparator, { className: "pcty-input-select__indicator-separator" }),
            React.createElement(InputIconBase, { "aria-hidden": "true", className: inputIconBaseClasses, ref: textInputIcon, tabIndex: 0 }, renderActionIcon({ toggle: inputIconToggle }))));
    };
    var getInputActionArea = function () {
        if (!renderInputActionArea || renderInputActionArea() === null)
            return;
        var actionAreaId = "".concat(id, "-input-action-area");
        return (React.createElement(InputBaseActionArea, { id: actionAreaId, ref: actionAreaRef }, renderInputActionArea(actionAreaId)));
    };
    var getLoadingIndicator = function () {
        if (!isLoading)
            return null;
        return React.createElement(InputLoader, null);
    };
    return (React.createElement(InputFullContainer, __assign({}, getAutomation(automationId, 'input-select-input-main-container'), otherProps, { className: inputBaseExtraStyles, id: "".concat(id, "-select-wrapper"), onMouseDown: function (e) { return handleInputContainerMouseDownFocus(e); }, styleNames: getStyleNames(styleNames) }),
        React.createElement(InputContainerBase, { className: inputContainerClasses },
            getInputActionArea(),
            React.createElement(InputBaseInputHolder, null,
                getLabelElement(),
                getInputElement()),
            getLoadingIndicator(),
            getClearButton()),
        React.createElement(InputBaseInputButtonContainer, { "aria-hidden": "true" }, getInputIcons())));
});
InputBase.defaultProps = {
    __TYPE: 'InputBase',
};
export default InputBase;
